import { AppThunkAction } from './appThunkAction';
import api from '../../helpers/api';
import { trackStatusForRequest } from './requestStatusActions';
import { RequestStatusType } from '../state/requestStatusState';
import { isRequestPending } from '../selectors/requestStatusSelectors';
import { JobDetails, JobPatchUpdate, JobSummary } from '../../models/dto/job';
import { AudioChannelSetting } from '../../models/dto/audioChannelSetting';

export function loadJobIfMissing(id: number): AppThunkAction {
	return (dispatch, getState) => {
		const state = getState();
		const jobs = state.jobs;
		
		if (jobs.details.has(id) || isRequestPending(state, RequestStatusType.LoadJob, id))
			return;

		const request = api.get<JobDetails>(`/api/jobs/${id}`).then(response => {
			dispatch({ type: 'jobs/details-loaded', job: response.data, id });
		});
		
		dispatch(trackStatusForRequest(request, RequestStatusType.LoadJob, id));
	}
}

export function completeJob(id: number): AppThunkAction {
	return (dispatch, getState) => {
		if (isRequestPending(getState(), RequestStatusType.CompleteJob, id))
			return;
		
		const request = api.put<JobSummary>(`/api/jobs/${id}/complete`).then((response) => {
			if (response.data.complete)
				dispatch({type: 'jobs/completed', id});
		});
		
		dispatch(trackStatusForRequest(request, RequestStatusType.CompleteJob, id));
	}
}

export function updateJobChannelSettings(id: number, audioChannel: AudioChannelSetting): AppThunkAction {
	return (dispatch, getState) => {
		if (isRequestPending(getState(), RequestStatusType.UpdateJobChannelSettings, id))
			return;

		const update: JobPatchUpdate = { audioChannel };
		const request = api.put<JobDetails>(`/api/jobs/${id}`, update).then((response) => {
			dispatch({type: 'jobs/channel-settings-updated', id, audioChannel: response.data.audioChannel});
		});

		dispatch(trackStatusForRequest(request, RequestStatusType.UpdateJobChannelSettings, id));
	}
}

export function updateJobCallStatuses(jobId: number): AppThunkAction {
 	return (dispatch, getState) => {
		api.get<JobDetails>(`/api/jobs/${jobId}`).then(response => {
			dispatch({ type: 'jobs/update-call-statuses', job: response.data });
		});
	};
}

export interface JobDetailsLoaded {
	type: 'jobs/details-loaded';
	job: JobDetails;
	id: number;
}

export interface JobCompleted {
	type: 'jobs/completed';
	id: number;
}

export interface JobChannelSettingsUpdated {
	type: 'jobs/channel-settings-updated';
	id: number;
	audioChannel: AudioChannelSetting | nundefined;
}

export interface JobUpdateCallStatusesAction {
    type: 'jobs/update-call-statuses';
	job: JobDetails;
}

export type JobsActions = JobDetailsLoaded | JobCompleted | JobChannelSettingsUpdated | JobUpdateCallStatusesAction;